import { render, staticRenderFns } from "./PictureODB.vue?vue&type=template&id=65e70908&scoped=true"
import script from "./PictureODB.vue?vue&type=script&lang=js"
export * from "./PictureODB.vue?vue&type=script&lang=js"
import style0 from "./PictureODB.vue?vue&type=style&index=0&id=65e70908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e70908",
  null
  
)

export default component.exports